// src/js/components/mobileNavigation.js
import { activateTrap, deactivateTrap } from '../utils/focusTrap.js';

export function initializeMobileNavigation() {
    const menuToggle = document.querySelector('.menu-toggle');
    const mobileMenuModal = document.getElementById('mobile-menu-modal');
    if (!menuToggle || !mobileMenuModal) return;

    const closeModalButton = mobileMenuModal.querySelector('.modal-close');

    const openMenu = () => {
        mobileMenuModal.classList.add('is-active');
        mobileMenuModal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('modal-open');
        menuToggle.setAttribute('aria-expanded', 'true');
        activateTrap(mobileMenuModal);
        if (closeModalButton) closeModalButton.focus();
    };

    const closeMenu = () => {
        deactivateTrap();
        menuToggle.focus(); // Flyttar tillbaka fokus
        
        mobileMenuModal.classList.remove('is-active');
        mobileMenuModal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('modal-open');
        
        mobileMenuModal.querySelectorAll('.menu-item-expanded').forEach(item => {
            item.classList.remove('menu-item-expanded');
        });
    };
    
menuToggle.addEventListener('click', openMenu);
    if (closeModalButton) closeModalButton.addEventListener('click', closeMenu);
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && mobileMenuModal.classList.contains('is-active')) closeMenu();
    });

    mobileMenuModal.addEventListener('click', (event) => {
        if (event.target === mobileMenuModal) {
            closeMenu();
            return;
        }

        const toggleIcon = event.target.closest('.sub-menu-toggle-icon');
        if (!toggleIcon) return;
        
        event.preventDefault();

        const parentLi = toggleIcon.closest('li.menu-item-has-children');
        if (!parentLi) return;

        const isOpening = !parentLi.classList.contains('menu-item-expanded');
        
        if (isOpening) {
            const parentUl = parentLi.parentNode;
            parentUl.querySelectorAll(':scope > .menu-item-expanded').forEach(openItem => {
                if (openItem !== parentLi) {
                    // Stäng syskonet
                    openItem.classList.remove('menu-item-expanded');
                    // ### KORRIGERING: Stäng även alla barn inuti syskonet ###
                    openItem.querySelectorAll('.menu-item-expanded').forEach(child => child.classList.remove('menu-item-expanded'));
                }
            });
        }
        
        if (!isOpening) {
            parentLi.querySelectorAll('.menu-item-expanded').forEach(openChild => {
                openChild.classList.remove('menu-item-expanded');
            });
        }

        parentLi.classList.toggle('menu-item-expanded');
    });

    console.log('Mobile Navigation initialized (final version with sibling-child fix).');
}